import { useEffect, useState } from "react";
// import CurrencyInput from "react-currency-input";
import DiscountService from "../../../services/DiscountService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { Snackbar } from "@material-ui/core";
import Select from "react-select";
import { TextField } from "@material-ui/core";

import { Alert } from "@material-ui/lab";
import makeAnimated from "react-select/animated";
import WarehouseService from "../../../services/WarehouseService";
import { useNavigate } from "react-router-dom";
import UtilsFormule from "../../../utils/UtilsFormule";

const styles = {
    container: (base) => ({
        ...base,
        flex: 1,
    }),
};
const AddDeclencheur = () => {
    const navigate = useNavigate();
    const [priorities, setPriorities] = useState([]);
    const [ordreProduct, setOrdreProduct] = useState(1);
    const [extrats, setExtrats] = useState([]);
    const [discounts, setDiscounts] = useState([]);
    const [allDiscounts, setAllDiscounts] = useState([]);

    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const animatedComponents = makeAnimated();
    const [selectedOptionDiscount, setSelectedOptionDiscount] = useState(null);
    const [discountSelectPlaceHolder, setDiscountSelectPlaceHolder] =
        useState(null);
    const [discountId, setDiscountId] = useState(0);
    const [discountLabel, setDiscountLabel] = useState("");

    const [startDate, setStartDate] = useState("any");
    const [endDate, setEndDate] = useState("any");
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [warehouses, setWarehouses] = useState([]);
    const [allWarehouse, setAllWarehouse] = useState([{}]);
    const [warehouseId, setWarehouseId] = useState([]);
    const [choosenWarehouse, setChoosenWarehouse] = useState(false);

    const [selectedOptionWarehouse, setSelectedOptionWarehouse] = useState(null);
    const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
        useState(null);
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successAlertText, setSuccessAlertText] = useState();
    const [listWarehouseId, setListWarehouseId] = useState([]);
    const [availableDeclencheurs, setAvailableDeclencheurs] = useState();
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const [infoAlertText, setInfoAlertText] = useState();
    const [choosenRulesWarehouses, setChoosenRulesWarehouses] = useState(0);

    useEffect(() => {
        WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
            .then((response) => {
                if (response.data.success) {
                    setWarehouses(response.data.success);
                } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : pas de dépôt");
                }
            })
            .catch((e) => {
                console.log("error in getAllRealWarehouse", e);
            });
        DiscountService.allDeclencheurs(getCurrentUserId(), 1, 0)
            .then((response) => {
                if (response.data.success) {
                    console.log("response", response.data.success)
                    setAvailableDeclencheurs(response.data.success);
                } else {
                    setOpenInfoAlert(true);
                    setInfoAlertText("Pas de Déclencheurs");
                }
            })
            .catch((e) => {
                console.log("error in allDiscounts", e);
            });
    }, []);
    useEffect(() => {
        discounts &&
            discounts.map((element) => {
                let exist = false;
                if (allDiscounts.length !== 0) {
                    for (let index = 0; index < allDiscounts.length; index++) {
                        if (allDiscounts[index].value === element?.id) {
                            exist = true;
                            break;
                        }
                    }
                }
                if (element?.id !== undefined && exist === false) {
                    setAllDiscounts((oldArray) => [
                        ...oldArray,
                        { value: element.id, label: element.libelle },
                    ]);
                }
                //here
            });
    }, [discounts]);

    useEffect(() => {
        warehouses &&
            warehouses.map((element) => {
                let exist = false;
                if (allWarehouse.length !== 0) {
                    for (let index = 0; index < allWarehouse.length; index++) {
                        if (allWarehouse[index].value === element?.id) {
                            exist = true;
                            break;
                        }
                    }
                }
                if (element?.id !== undefined && exist === false) {
                    setAllWarehouse((oldArray) => [
                        ...oldArray,
                        { value: element.id, label: element.name },
                    ]);
                }
                //here
            });
    }, [warehouses]);
    const onChangeSelectedWarehouse = (selectedOption) => {
        // setWarehouseSelectPlaceHolder();
        // console.log(selectedOption)
        // setWarehouseId(selectedOption.value);
        setWarehouseSelectPlaceHolder();
        console.log(selectedOption)
        setListWarehouseId(selectedOption);
        setChoosenWarehouse(true);
    };

    function addClickParProduct() {
        setExtrats((oldArray) => [
            ...oldArray,
            {
                order: ordreProduct,
                discountName: discountLabel,
                discountId: discountId,
                // percent: percent,
            },
        ]);
        setOrdreProduct(ordreProduct + 1);
    }
    const onChangeSelectedDiscount = (selectedOption) => {
        setDiscountSelectPlaceHolder();
        console.log(selectedOption);
        setDiscountId(selectedOption.value);
        setDiscountLabel(selectedOption.label)
    };
    function createUIParProducts() {
        return (
            <div class="row">
                <div className="col-sm-5">
                    <label>Priorité</label>
                    <br />
                    <label>{ordreProduct}</label>
                </div>
                <div className="col-sm-7">
                    <label>Choisir une règle</label>

                    <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOptionDiscount}
                        onChange={onChangeSelectedDiscount}
                        options={allDiscounts}
                        placeholder={discountSelectPlaceHolder}
                    />
                </div>
            </div>
        );
    }
    function addExtratToViewParProduct() {
        if (extrats.length === 0) {
            return (
                <div class="row">
                    <div class="col-xs-12 table-responsive">
                        <h1></h1>
                    </div>
                </div>
            );
        } else if (
            extrats.length === 1 &&
            extrats[0]["order"] === "" &&
            extrats[0]["discountName"] === ""
        ) {
            return (
                <div class="row">
                    <div class="col-xs-12 table-responsive">
                        <h1></h1>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead className="text-center">
                            <td>Priorité</td>
                            <td>discountName</td>
                            <td>Supprimer</td>
                        </thead>
                        <tbody>
                            {extrats.map((extrat, i) => (
                                <tr className="text-center">
                                    <td>{extrat.order}</td>
                                    <td>{extrat.discountName}</td>

                                    <td>
                                        <button
                                            type="button"
                                            class="btn btn-danger "
                                            onClick={() => removeExtratParProduct(i)}
                                        >
                                            <i class="fa fa-minus"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }
    }
    const removeExtratParProduct = (index) => {
        var array = [...extrats];

        if (index !== -1) {
            array.splice(index, 1);
            setExtrats(array);
        }
    };
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    const onChangeStartDate = (event) => {
        setStartDate(event.target.value.concat(":59"));
    };
    const onChangeEndDate = (event) => {
        setEndDate(event.target.value.concat(":59"));
    };
    const onChangeNameHandler = (event) => {
        setName(event.target.value);
    };
    const onChangeDescriptionHandler = (event) => {
        setDescription(event.target.value);
    };
    const onChooseWarehouseHandler = (event) => {
        if (choosenWarehouse) {
            let rule = {
                idUser: getCurrentUserId(),
                isActive: 1,
                isDeleted: 0,
                warehouses: listWarehouseId,

            };
            console.log("rule", JSON.stringify(rule))
            DiscountService.allRulesByWarehouse(rule)
                .then((response) => {
                    console.log("allDiscounts", response);
                    setAllDiscounts([]);
                    if (response.data.success) {
                        response.data.success.map((element) => {
                            let exist = false;
                            if (allDiscounts.length !== 0) {
                                for (let index = 0; index < allDiscounts.length; index++) {
                                    if (allDiscounts[index].value === element?.id) {
                                        exist = true;
                                        break;
                                    }
                                }
                            }
                            if (element?.id !== undefined && exist === false) {
                                setAllDiscounts((oldArray) => [
                                    ...oldArray,
                                    { value: element.id, label: element.libelle },
                                ]);
                            }
                            //here
                        });
                        setChoosenRulesWarehouses(1);
                    } else {
                        setOpenErrorAlert(true);
                        setErrorAlertText("Erreur : pas de dépôt");
                    }
                })
                .catch((e) => {
                    console.log("error in getAllRealWarehouse", e);
                });
        }


    }
    const handleSuccessClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSuccessAlert(false);
    };
    const onValidHandler = () => {
        if (name == null) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :le nom est vide ! ");
        } else if (description == null) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :la description est vide ! ");
        }

        let addDeclencheurModel = {
            libelle: name,
            description: description,
            idUser: getCurrentUserId(),
            startDate: startDate,
            endDate: endDate,
            warehouses: listWarehouseId,
            priorities: extrats,
        };
        console.log("addDeclencheurModel", JSON.stringify(addDeclencheurModel));

        DiscountService.addDeclencheur(addDeclencheurModel).then(
            (result) => {
                console.log("result", result.data["success"]);
                if (result.data["success"]) {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                        navigate(`/discount`);
                    }, 2000);
                } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur :erreur serveur ");
                }
            }
        );
    };
    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const listRulesWarehouse = () => {
        if (choosenRulesWarehouses === 0) {
            return (<div className="col-sm-12"><label>Vous devez choisir un dépôt et appuiller sur le bouton choisir</label></div>)

        } else if (choosenRulesWarehouses === 1) {
            return (
            <div className="col-sm-12">
                {createUIParProducts()}
                <br />
                <label></label>
                <button
                    style={{ height: "40 px", width: "40 px" }}
                    type="button"
                    className="btn btn-dark float-right"
                    onClick={addClickParProduct}
                >
                    <i class="fa fa-plus"></i>
                </button>
                {addExtratToViewParProduct()}
            </div>
            )

        }
    };
    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">Home</li>
                                <li class="breadcrumb-item active">Ajouter Priorité</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section class="content">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Declencheur disponible</h3>

                        <div class="card-tools">
                            <button
                                type="button"
                                class="btn btn-tool"
                                data-card-widget="collapse"
                                title="Collapse"
                            >
                                <i class="fas fa-minus"></i>
                            </button>
                        </div>
                        <br />
                        <br />
                        {availableDeclencheurs && (<p>{availableDeclencheurs.refCC}-{availableDeclencheurs.nameCC}</p>)}

                        {availableDeclencheurs && (<p><b>Du</b> {UtilsFormule.formatDate(availableDeclencheurs.startDate)} <b>jusqu'à </b>{UtilsFormule.formatDate(availableDeclencheurs.endDate)}</p>)}
                        <p><b>Les dépôts</b></p>
                        {availableDeclencheurs && availableDeclencheurs.warehouses.map((element, i) => (<p>{element.label}</p>))}
                    </div>
                    <div class="card-body p-0">
                        <table class="table  projects">
                            <thead>
                                <tr>
                                    <th>Règle </th>
                                    <th>Priorité</th>

                                    <th className="text-center" style={{ width: "12%" }}>
                                        Modifier
                                    </th>
                                    <th className="text-center" style={{ width: "12%" }}>
                                        Voir Plus
                                    </th>
                                    <th className="text-center" style={{ width: "12%" }}>
                                        Archiver
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {availableDeclencheurs &&
                                    availableDeclencheurs.priorities.map((element, i) => (
                                        <tr key={element.order}>
                                            <td>{element.discountName}</td>
                                            <td>{element.order}</td>
                                            <td className="text-center">
                                                <button
                                                    style={{ width: 40 }}
                                                    class="btn bg-gray btn-sm "
                                                    data-toggle="modal"
                                                    data-target="#edit-brand"
                                                // onClick={() =>
                                                //     onEditBrandHandler(
                                                //         element.id,
                                                //         element.name,
                                                //         element.description
                                                //     )
                                                // }
                                                >
                                                    <i class="fas fa-pencil-alt"></i>
                                                </button>
                                            </td>

                                            <td className="text-center">
                                                <button
                                                    style={{ width: 40 }}
                                                    class="btn bg-black btn-sm "
                                                // onClick={() =>
                                                //     onViewProductsHandler(
                                                //         element.id,
                                                //         element.name
                                                //     )
                                                // }
                                                >
                                                    <i class="fas fa-shopping-cart"></i>
                                                </button>
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    style={{ width: 40 }}
                                                    class="btn btn-danger btn-sm"
                                                // onClick={() =>
                                                //      onArchiveHandler(element.id, 1)
                                                // }
                                                >
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            <section className="content ">
                <div className="container-fluid">
                    <div className="timeline">
                        <div className="time-label">
                            <span style={{ backgroundColor: "black" }}>
                                <span style={{ color: "white" }}>Ajouter déclencheur</span>
                            </span>
                        </div>
                        <div>
                            <i className="fas fa-1 " style={{ backgroundColor: "black" }}>
                                <span style={{ color: "white" }}>1</span>
                            </i>
                            <div className="timeline-item">
                                <span className="time">
                                    <i className="fas fa-clock" /> 12:05
                                </span>
                                <h3 className="timeline-header">
                                    <b>Informations Générales</b>
                                </h3>
                                <div className="timeline-body">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label htmlFor="inputName">Libellé</label>
                                                <input
                                                    onChange={onChangeNameHandler}
                                                    type="text"
                                                    id="inputName"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label htmlFor="inputDescription">Description</label>
                                                <textarea
                                                    value={description}
                                                    placeholder="Saisir..."
                                                    onChange={onChangeDescriptionHandler}
                                                    id="inputDescription"
                                                    className="form-control"
                                                    rows={4}
                                                    defaultValue={""}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <i className="fas fa-2 " style={{ backgroundColor: "black" }}>
                                <span style={{ color: "white" }}>2</span>
                            </i>
                            <div className="timeline-item">
                                <span className="time">
                                    <i className="fas fa-clock" /> 12:05
                                </span>
                                <h3 className="timeline-header">
                                    <b>Choisir le dépot</b>
                                </h3>
                                <div className="timeline-body">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label>Choisir le/ les dépôt</label>
                                                <Select
                                                    styles={styles}
                                                    isMulti
                                                    closeMenuOnSelect={true}
                                                    components={animatedComponents}
                                                    defaultValue={selectedOptionWarehouse}
                                                    onChange={onChangeSelectedWarehouse}
                                                    options={allWarehouse}
                                                    placeholder={warehouseSelectPlaceHolder}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12">                                            <button
                                            class="btn btn-dark float-right"
                                            style={{ marginTop: "1%" }}
                                            onClick={onChooseWarehouseHandler}
                                        >
                                            Choisir
                                        </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <i className="fas fa-3 " style={{ backgroundColor: "black" }}>
                                <span style={{ color: "white" }}>3</span>
                            </i>
                            <div className="timeline-item">
                                <span className="time">
                                    <i className="fas fa-clock" /> 5 mins ago
                                </span>
                                <h3 className="timeline-header no-border">
                                    <b>Choisir le type de la promotion</b>{" "}
                                </h3>
                                <div className="timeline-body">
                                    <div className="row">
                                        {listRulesWarehouse()}

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <i className="fas fa-6" style={{ backgroundColor: "black" }}>
                                <span style={{ color: "white" }}>4</span>
                            </i>
                            <div className="timeline-item">
                                <span className="time">
                                    <i className="fas fa-clock" /> 27 mins ago
                                </span>
                                <h3 className="timeline-header">
                                    <b> Choisir la période de la promotion</b>
                                </h3>
                                <div className="timeline-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="inputName">Date début</label>

                                                <TextField
                                                    style={{ width: "100%" }}
                                                    className="col-sm-12"
                                                    variant="outlined"
                                                    value={startDate}
                                                    onChange={onChangeStartDate}
                                                    id="datetime-local"
                                                    type="datetime-local"
                                                    defaultValue="date"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    size="small"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="inputName">Date fin</label>

                                                <TextField
                                                    style={{ width: "100%" }}
                                                    className="col-sm-12"
                                                    variant="outlined"
                                                    value={endDate}
                                                    onChange={onChangeEndDate}
                                                    id="datetime-local"
                                                    type="datetime-local"
                                                    defaultValue="date"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    size="small"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button
                                class="btn btn-dark"
                                style={{ marginTop: "1%" }}
                                onClick={onValidHandler}
                            >
                                Confirmer
                            </button>
                        </div>
                    </div>

                </div>
            </section >



            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openInfoAlert}
                autoHideDuration={4000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleInfoClose} severity="error">
                    {infoAlertText}
                </Alert>
            </Snackbar>

            <Snackbar
                open={openSuccessAlert}
                autoHideDuration={2000}
                onClose={handleSuccessClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleSuccessClose} severity="success">
                    {successAlertText}
                </Alert>
            </Snackbar>
        </div >
    );
};
export default AddDeclencheur;
